/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timecode_Offset_FormInputs */

const en_timecode_offset_form = /** @type {(inputs: Timecode_Offset_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode offset form`)
};

const fr_timecode_offset_form = /** @type {(inputs: Timecode_Offset_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulaire de décalage de timecode`)
};

const de_timecode_offset_form = /** @type {(inputs: Timecode_Offset_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode-Offset-Formular`)
};

const it_timecode_offset_form = /** @type {(inputs: Timecode_Offset_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modulo di offset del codice temporale`)
};

const ru_timecode_offset_form = /** @type {(inputs: Timecode_Offset_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Форма смещения временного кода`)
};

const es_timecode_offset_form = /** @type {(inputs: Timecode_Offset_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulario de desplazamiento del código de tiempo`)
};

const zh_cn2_timecode_offset_form = /** @type {(inputs: Timecode_Offset_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间码偏移表单`)
};

const ja_timecode_offset_form = /** @type {(inputs: Timecode_Offset_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコードオフセットフォーム`)
};

const hi_timecode_offset_form = /** @type {(inputs: Timecode_Offset_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमकोड ऑफ़सेट फ़ॉर्म`)
};

const pt_pt2_timecode_offset_form = /** @type {(inputs: Timecode_Offset_FormInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`formulário de deslocamento de código de tempo`)
};

/**
* | output |
* | --- |
* | "Timecode offset form" |
*
* @param {Timecode_Offset_FormInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timecode_offset_form = /** @type {((inputs?: Timecode_Offset_FormInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timecode_Offset_FormInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timecode_offset_form(inputs)
	if (locale === "de") return de_timecode_offset_form(inputs)
	if (locale === "it") return it_timecode_offset_form(inputs)
	if (locale === "ru") return ru_timecode_offset_form(inputs)
	if (locale === "es") return es_timecode_offset_form(inputs)
	if (locale === "zh-CN") return zh_cn2_timecode_offset_form(inputs)
	if (locale === "ja") return ja_timecode_offset_form(inputs)
	if (locale === "hi") return hi_timecode_offset_form(inputs)
	if (locale === "pt-PT") return pt_pt2_timecode_offset_form(inputs)
	return en_timecode_offset_form(inputs)
});